export const typography = {
    family: {
        body: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
        mono: "ui-monospace, 'Cascadia Mono', 'Consolas', monospace",
    },
    size: {
        xs: "0.75rem",
        sm: "0.85rem",
        md: "0.95rem",
        lg: "1.05rem",
        xl: "1.25rem",
        "2xl": "1.6rem",
        "3xl": "2rem",
    },
    weight: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
    leading: {
        tight: 1.15,
        normal: 1.45,
    },
    tracking: {
        tight: "-0.02em",
        normal: "0",
        eyebrow: "0.06em",
    },
} as const;

export type FontSizeKey = keyof typeof typography.size;
export type FontWeightKey = keyof typeof typography.weight;
